<template lang="html">
  <div>
    <server-form
      v-slot="slotProps"
      :form-action="formAction"
      :form="form">
      <div class="row">
        <div class="col-md-12">
          <my360Input
            :form="form"
            :error-bag="slotProps.errors"
            :label="__('label_job_title')"
            :generic-error-msg="__('feedback_job_title')"
            class="vue-input-white"
            required
            autofocus
            prop="job_role"/>

          <my360Select
            :form="form"
            :error-bag="slotProps.errors"
            :label="__('label_experience_level')"
            :generic-error-msg="__('feedback_experience_level')"
            :options="experienceLevels"
            class="vue-input-white"
            required
            prop="experience_level"/>
        </div>
      </div>
    </server-form>
  </div>
</template>
<script>
import formAction from '../mixins/formAction'
export default {
  name: 'SurveySetup',

  mixins: [formAction],

  props: {
    experienceLevels: {
      type: [Object, Array],
      required: true
    }
  },

  data () {
    return {
      form: {}
    }
  }
}
</script>
